import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import FaqComponents from "../components/common/faq";

const faqs = [
  {
    question: " How much does it cost to hire a mobile app developer?",
    answer: ` <p>When a company decides to hire a mobile app developer, the usual question of cost arises. According to data from Indeed.com, hiring a US-based mobile app developer typically requires an annual payment of $120,000.</p>`,
  },
  {
    question: "Can I hire someone to build an app",
    answer: `<p>Hiring a freelance app developer is ideal if you're beginning with a limited budget. However, for enterprise-level software, a comprehensive development team or partnership with an app development company is necessary.</p>`,
  },
  {
    question: "How long will it take to build a mobile app?",
    answer: ` <p>The timeline for app development varies: smaller apps can be completed in about 2 months, mid-sized ones in 3-3.5 months, and larger ones in 5-6 months. This process includes technical architecture, UI coding, backend setup, functional implementation, integration, and testing.</p>`,
  },
  {
    question: "Who should I hire to build an app?",
    answer: `<p>Usually, an application development team is based on 5-7 experts, including a Quality Assurance Engineer, Project Manager, iOS and/or Android mobile app developers, backend (server-side) developer, and UX/UI Designer. This whole squad ensures comprehensive coverage across all necessary areas for successful application creation.</p>`,
  },
  {
    question: " How many developers are needed to build a mobile app?",
    answer: `<p>If you are initializing the first project of mobile development for your business, it's advisable to engage a product manager to prevent critical mistakes that might lead to project failure. So, at least a minimum of 4 to 10 people, is required for any project to create a successful mobile app.</p>`,
  },
];

function FaqLocation(props) {
  return (
    <div className="faq_loc p-100 tekrevol_dark_bg">
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <div className="example center text-center" data-text="FAQs">
              <h2>Hire Mobile App Developers FAQs</h2>
            </div>
          </Col>
        </Row>
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="services_faqs"
          >
            <FaqComponents faqs={faqs} />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default FaqLocation;
